import { StackLayout } from '@progress/kendo-react-layout'
import { FC } from 'react'
import { useAppSelector } from '../../../stores'
import { BuildingHistoryItem } from './BuildingHistoryItem'

export interface BuildingHistoryItemListProps {
  skip: number
}
export const BuildingSearchResultList: FC<BuildingHistoryItemListProps> = ({
  skip
}) => {
  const buildingHistoryList = useAppSelector(
    (state) => state.buildingHistory.buildingHistoryList
  )
  return (
    <StackLayout orientation="vertical" gap={3}>
      {buildingHistoryList.slice(skip, skip + 20).map((item, index) => {
        return (
          <BuildingHistoryItem
            key={index}
            data={item}
            skip={skip}
            itemIndex={index}
          />
        )
      })}
    </StackLayout>
  )
}
